<script>
	import Navbar from "../Components/Navbar/Navbar.svelte";
	import NftMarket from "../Components/NftMarket/NftMarket.svelte";
	import NftMarketMobile from "../Components/NftMarket/NftMarketMobile.svelte"; 
    import Footer from "../Components/Footer/Footer.svelte";
    import NavbarMobile from "../Components/Navbar/NavbarMobile.svelte";
	import FooterMobile from "../Components/Footer/FooterMobile.svelte";
	import { store } from '../store.js';

	import { onMount } from "svelte";

	import DATA from "../Data/data";

	let loaded = false;

	const pageName = 'nft';

	let iw, ow;
	let img;
	
	onMount(() => {
		loaded = true;
	});

	function updateBackground() {
		if(!img || !img.src.includes(`${$store.type}`)) {
			img = new Image();
			img.onload = function() {
				store.update(s => ({...s, imageWidth: this.width, imageHeight: this.height}))
			}
			img.src = `/images/${pageName}-${$store.type}.png`;
		}

	}
	
	onMount(() => {		
		updateBackground();
		console.log('WTF NFT')

		window.addEventListener('resize', updateBackground);
		
		return () => {
			window.removeEventListener('resize', updateBackground);
		}
	});
</script>
<svelte:window bind:innerWidth={iw} bind:outerWidth={ow} />
{#if loaded}
	<div style={
		$store.type === 'pc' ? 
		`background: linear-gradient(90deg, rgb(28 28 47) 0%, rgb(32 35 54) 28%, rgb(49 66 88) 59%, rgb(63 89 114) 79%, rgb(65 93 118) 100%);;`
		:
		`background: linear-gradient(90deg, rgb(0 0 0) 0%, rgb(0 0 0) 28%, rgb(0 0 0) 59%, rgb(0 0 0) 79%, rgb(0 0 0) 100%);`
	}>
		<div 
			class="wrapper" 
			class:dev={$store.isDev}
			style={
				`background: url(/images/${pageName}-${$store.type}.png) no-repeat;
				background-size: 100% ${$store.imageHeight * $store.r}px;
				height: ${$store.imageHeight * $store.r + 200}px;`
			}
			>

			{#if $store.type === 'pc'}
			<Navbar logo={true} navlists={DATA.NAVBAR_DATA} header={DATA.HEADER} />
			<NftMarket />
			<Footer white={true} footerHeight={100} footerData={DATA.FOOTER_DATA} />
			{:else}
			<NavbarMobile logo={true} navlists={DATA.NAVBAR_DATA} header={DATA.HEADER} />
			<NftMarketMobile />
			<FooterMobile white={true} footerData={DATA.FOOTER_DATA} />
			{/if}

		</div>
	</div>

{/if}
